import { AxiosResponse } from 'axios';
import { jobBoardAPI } from './base';

const jobStageEndpoint = {
  getAll: '/job-stage',
  create: '/job-stage',
  update: '/job-stage/:{id}'
};
export interface JobStage {
  id: string;
  name: string;
  description: string;
  createdAt: string;
}
export interface JobStageDTO {
  name: string;
  description: string;
}

export const GET_JOBSTAGE_QUERY = async (): Promise<
  AxiosResponse<JobStage[]>
> => (await jobBoardAPI.get(jobStageEndpoint.getAll)).data;

export const CREATE_JOB_STAGE = async (
  data: JobStageDTO
): Promise<AxiosResponse<JobStage>> =>
  jobBoardAPI.post(jobStageEndpoint.create, data);

export const PATCH_JOB_STAGE = async ({
  data,
  jobId
}: {
  data: JobStageDTO;
  jobId: string;
}): Promise<AxiosResponse<JobStage>> =>
  jobBoardAPI.patch(jobStageEndpoint.update.replace(':{id}', jobId), data);

export const DELETE_JOB_STAGE = async (
  jobId: string
): Promise<AxiosResponse<void>> => {
  const endpoint = `/job-stage/${jobId}`;
  return jobBoardAPI.delete(endpoint);
};
